import { MilestoneWinner } from '../../state/communityJackpot.types';

export const sortWinners = (winners: MilestoneWinner[]) =>
  [...winners].sort(
    (w1, w2) =>
      w2.amount - w1.amount || w1.screenName.localeCompare(w1.screenName),
  );
